import { Input, YesObject } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'

import { StyledSideMenu } from './EditTools.styles'

const SideMenu = ({ sitemodel }: { sitemodel: YesObject }) => {
  const { t } = useTranslation()
  return (
    <StyledSideMenu>
      <h2>{t('edit-tools.sitemodel-data-title')}</h2>

      {/* Daqui pra baixo precisa ser dinâmico, com dados do masterdata */}
      <Input
        label='UUID do Sitemodel'
        value={sitemodel?.uuid || ''}
        heightClass='regular'
        informational
      />
      <Input
        label='Des'
        value={sitemodel?.des || ''}
        heightClass='regular'
        informational
      />
    </StyledSideMenu>
  )
}

export default SideMenu
